module.exports = __webpack_public_path__ + "img/m1-back.1a04ec71.jpg";